







































































import { Component, Prop } from 'vue-property-decorator';
import ChangePlanItem from './change-plan-item.vue';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import IntercomMixin from '@/components/helpers/intercom-mixin';
import { PLAN_LIMITS_LOGIC } from '@/services/constants/planLimits';

@Component({
  components: {
    ChangePlanItem
  }
})
export default class ChangePlanDetails extends mixins<PlanLimitsMixin,IntercomMixin>(PlanLimitsMixin,IntercomMixin) {
  plan: Billing.BillingPlan = null;

  @Prop()
  planLimits: keyof BillingLimits | {
    logic: PLAN_LIMITS_LOGIC.AT_LEAST_ONE_REQUIRED | PLAN_LIMITS_LOGIC.ALL_REQUIRED,
    addons: (keyof BillingLimits)[]
  };

  get isOnePlanLimit() {
    return typeof this.planLimits === 'string'
  }

  @Prop()
  handlePlanSelect;
 
  get getTitleNeedMore() {
    switch (this.planLimits) {
      case 'memberAdminsAmount':
      case 'memberUsersAmount':
        return this.t('Need more members?')
      case 'domainsAmount':
      case 'redirectDomainsAmount':
        return this.t('Need more domains?')
      case 'campaignsAmount':
      case 'offersAmount':
      case 'landingsAmount':
      case 'flowsAmount':
      case 'trafficSourcesAmount':
      case 'affiliateNetworksAmount':
        return this.t('Ran out of active elements?')   
      case 'customColumnsAmount':
        return this.t('Need more columns?')
      case 'sharedReportsAmount':
        return this.t('Need more shared reports?')
      case 'customConversionsAmount':
        return this.t('Need more custom conversions?')
    }
  }
 
  get getSubTitleNeedMore() {
    switch (this.planLimits) {
      case 'memberAdminsAmount':
      case 'memberUsersAmount':
        return this.t('Remove the members that are no longer required or contact our team to request more members.')
      case 'domainsAmount':
      case 'redirectDomainsAmount':
        return this.t('Delete the domains that are no longer required or contact our team to request more domains.') 
      case 'campaignsAmount':
      case 'offersAmount':
      case 'landingsAmount':
      case 'flowsAmount':
      case 'trafficSourcesAmount':
      case 'affiliateNetworksAmount':
        return this.t('Archive the elements that are no longer required or contact our team to request more elements.')
      case 'customColumnsAmount':
        return this.t('Delete the columns that are no longer required or contact our team to request more columns.')
      case 'sharedReportsAmount':
        return this.t('Delete the reports that are no longer required or contact our team to request more shared reports.')
      case 'customConversionsAmount':
        return this.t('Delete the custom conversions that are no longer required or contact our team to request more conversions.')
    }
  }
 
  get getTitle() {
    if(typeof this.planLimits !== 'string' && JSON.stringify(this.planLimits?.addons) === '["ivtIpIsDatacenter","ivtIpIsBlacklisted","ivtFastClicker","ivtIpWithFrequentCampaignEvents","ivtIpWithFrequentEvents"]'){
      return this.t('Wish to identify and manage the invalid traffic in your campaigns?')
    }
    
    switch (this.planLimits) {
      case 'domainsAmount':
        return this.t('Need more tracking domains?')
      case 'redirectDomainsAmount':
        return this.t('Need more cloaking domains?')
      case 'campaignsAmount':
        return this.t('Need more campaigns?')
      case 'offersAmount':
        return this.t('Need more offers?')
      case 'landingsAmount':
        return this.t('Need more landing pages?')
      case 'flowsAmount':
        return this.t('Need more flows?')
      case 'trafficSourcesAmount':
        return this.t('Need more traffic sources?')
      case 'affiliateNetworksAmount':
        return this.t('Need more affiliate networks?')
      case 'customColumnsAmount':
        return this.t('Enrich your reports with the your own custom metrics.')
      case 'doubleMetaRedirect':
        return this.t('Hide your landing pages and traffic source data from affiliate networks.')
      case 'bulkEditCampaigns':
      case 'bulkEditOffers':
      case 'bulkEditLandings':
        return this.t('Use bulk edit to change the parameters, domains and other settings of elements quickly.')
      case 'webViewCondition':
      case 'crawlerCondition':
      case 'uniquenessPeriodCondition':
      case 'botMarkCondition':
      case 'referrerDomainCondition':
      case 'proxyCondition':
      case 'visitCapCondition':
      case 'externalIdCondition':
        return this.t('Use advanced rules for the smart traffic distribution in your campaigns.')
      case 'importOffers':
        return this.t('Optimize the routine - add multiple offers with one click.')
      case 'importLandings':
        return this.t('Optimize the routine - add multiple landing pages with one click.')
      case 'bulkReportCampaign':
      case 'bulkReportOffer':
      case 'bulkReportLanding':
      case 'bulkReportFlow':
      case 'bulkReportTrafficSource':
      case 'bulkReportAffiliateNetwork':
      case 'bulkReportCustomParams':
        return this.t('Learn more about the traffic to optimize your campaigns.')
      case 'botFiltersAccess':
        return this.t('Control the bot traffic with flexible conditions and actions.')
      case 'uniquenessPeriod':
        return this.t('Wish to change the settings of traffic uniqueness for a campaign?')
      case 'customConversionsAmount':
        return this.t('Need more custom conversions?')
      case 'memberAdminsAmount':
        return this.t('Need more admin roles?')
      case 'memberUsersAmount':
        return this.t('Need more user roles?')
      case 'tagsCampaigns':
      case 'tagsOffers':
      case 'tagsAffiliateNetworks':
      case 'tagsLandings':
      case 'tagsFlows':
      case 'tagsTrafficSources':
        return this.t('Use tags to group and organize your work with the elements.')
      case 'trafficLossCampaign':
        return this.t('Wish to set up the traffic loss % on the level of a campaign?')
      case 'landingPageProtection':
        return this.t('Hide your landing pages from the competitors and spy tools.')
      case 'sharedReportsAmount':
        return this.t('Create shared reports with the real-time data without granting the access to your account.')
      case 'sendPostbacksCampaign':
        return this.t('Use the option of hiding the initial amount of conversions for a campaign from your traffic source.')
      case 'markersCampaigns':
      case 'markersCustomParams':
      case 'markersAffiliateNetworks':
      case 'markersTrafficSources':
      case 'markersFlows':
      case 'markersLandings':
      case 'markersOffers':
        return this.t('Visualize your reports with marks - highlight the elements or custom parameters for further optimization.')
      case 'trafficSourceParamMasking':
        return this.t('Wish to hide the zones, websites and other traffic data from your affiliate networks?')
      case 'integrationMgid':
      case 'integrationPropellerads':
      case 'integrationExoclick':
      case 'integrationTrafficjunky':
      case 'integrationRevcontent':
      case 'integrationFacebookConversions':
        return this.t('Use API integrations to see more accurate data in your reports and automate the campaigns\' management.')
      case 'smartRotations':
        return this.t('Use advanced rotations and fix-on option to distribute traffic smartly between paths, landing pages and offers.')
      case 'dataRetention':
        return this.t('Wish to see the data for previous months?')
      case 'ivtIpIsDatacenter':
      case 'ivtIpIsBlacklisted':
      case 'ivtFastClicker':
      case 'ivtIpWithFrequentCampaignEvents':
      case 'ivtIpWithFrequentEvents':
        return this.t('Wish to identify and manage the invalid traffic in your campaigns?')
    }
  }

  get getSubTitle() {
    if(typeof this.planLimits !== 'string' && JSON.stringify(this.planLimits?.addons) === '["ivtIpIsDatacenter","ivtIpIsBlacklisted","ivtFastClicker","ivtIpWithFrequentCampaignEvents","ivtIpWithFrequentEvents"]'){
      return `${this.t('Upgrade the subscription to enable the option or purchase it as add-on.')} <br> ${this.t('You should purchase all the features as add-ons or change the subscription to see the total amount of suspicious traffic.')}`
    }
    
    switch (this.planLimits) {
      case 'domainsAmount':
      case 'redirectDomainsAmount':
      case 'campaignsAmount':
      case 'offersAmount':
      case 'landingsAmount':
      case 'flowsAmount':
      case 'trafficSourcesAmount':
      case 'affiliateNetworksAmount':
      case 'customConversionsAmount':
      case 'memberAdminsAmount':
      case 'memberUsersAmount':
      case 'dataRetention':
        return this.t('Upgrade the subscription to enable or purchase more as add-on.')
      case 'customColumnsAmount':
        return this.t('Upgrade the subscription to enable or purchase more columns as add-on.')
      case 'bulkEditCampaigns':
      case 'bulkEditOffers':
      case 'bulkEditLandings':
      case 'webViewCondition':
      case 'crawlerCondition':
      case 'proxyCondition':
      case 'referrerDomainCondition':
      case 'externalIdCondition':
      case 'botMarkCondition':
      case 'uniquenessPeriodCondition':
      case 'doubleMetaRedirect':
      case 'uniquenessPeriod':
      case 'sendPostbacksCampaign':
      case 'trafficLossCampaign':
      case 'landingPageProtection':
      case 'tagsCampaigns':
      case 'tagsOffers':
      case 'tagsLandings':
      case 'tagsFlows':
      case 'tagsTrafficSources':
      case 'trafficSourceParamMasking':
      case 'tagsAffiliateNetworks':
      case 'visitCapCondition':
      case 'integrationMgid':
      case 'integrationPropellerads':
      case 'integrationExoclick':
      case 'integrationTrafficjunky':
      case 'integrationRevcontent':
      case 'integrationFacebookConversions':
      case 'smartRotations':
      case 'bulkReportCustomParams':
        return this.t('Upgrade the subscription to unlock the feature or purchase it as add-on.')
      case 'importOffers':
        return this.t('Upgrade the subscription to unlock the offers import or purchase it as add-on.')
      case 'importLandings':
        return this.t('Upgrade the subscription to unlock the landings import or purchase it as add-on.')
      case 'bulkReportCampaign':
      case 'bulkReportOffer':
      case 'bulkReportLanding':
      case 'bulkReportFlow':
      case 'bulkReportTrafficSource':
      case 'bulkReportAffiliateNetwork':
        return this.t('Upgrade the subscription to unlock the bulk reports or purchase it as add-on.')
      case 'markersCampaigns':
      case 'markersOffers':
      case 'markersLandings':
      case 'markersFlows':
      case 'markersAffiliateNetworks':
      case 'markersTrafficSources':
      case 'markersCustomParams':
        return this.t('Upgrade the subscription to unlock the marks or purchase it as add-on.')
      case 'sharedReportsAmount':
        return this.t('Upgrade the subscription to enable the option and create more reports or purchase it as add-on.')
      case 'botFiltersAccess':
        return this.t('Upgrade the subscription to set up the bot filters or purchase it as add-on.')
      case 'ivtIpIsDatacenter':
      case 'ivtIpIsBlacklisted':
      case 'ivtFastClicker':
      case 'ivtIpWithFrequentCampaignEvents':
      case 'ivtIpWithFrequentEvents':
        return this.t('Upgrade the subscription to enable the option or purchase it as add-on.')
    }
  }

  get enabledPlanLimit() {
    const limits = this.plan?.limits;
    if (!limits) return [];

    return Object.keys(limits).filter(item => limits[item]);
  }

  findNextPlanIndex(planLimit) {
    const allPlans = this.$store.state.billingPlans as Billing.BillingPlan[];
    if(typeof this.$PL[planLimit] === 'number'){
      const { limits } = this.$store.state.billing;
      return allPlans.findIndex(item => {
        return +item.limits[planLimit] > +limits[planLimit]
      });
    }else {
      return allPlans.findIndex(plan => {
        return plan.limits[planLimit];
      });
    }
  }

  mounted() {
    let planIndex=null;

    if(this.isOnePlanLimit){
      planIndex = this.findNextPlanIndex(this.planLimits)
    }else{
      const planIndexes=[]
      if(typeof this.planLimits !== 'string'){
        this.planLimits.addons.forEach((planLimit)=>{
          if(!this.$store.state.billing.addons[planLimit]){
            planIndexes.push(this.findNextPlanIndex(planLimit))
          }
        });
      }

      if(typeof this.planLimits !== 'string' && this.planLimits?.logic === PLAN_LIMITS_LOGIC.ALL_REQUIRED){
        planIndex= planIndexes.reduce((acc,key)=>{
          if(key>acc){
            acc=key
          }
          return acc;
        },planIndexes[0]);
      }

      if(typeof this.planLimits !== 'string' && this.planLimits?.logic === PLAN_LIMITS_LOGIC.AT_LEAST_ONE_REQUIRED){
        planIndex= planIndexes.reduce((acc,key)=>{
          if(key<acc){
            acc=key
          }
          return acc;
        },planIndexes[0]);
      }
    }
    this.plan = this.$store.state.billingPlans[planIndex]
    this.handlePlanSelect(this.plan || {});
  }

  byAsAddonHandle(limit) {
    this.$emit('close');
    this.bus.emit('open-dialog',{name: 'manageAddon',data: {planLimit:limit}});
  }
}
